import { checkLoginByCodeApi } from '../../api';
import { useEffect, useRef, useState } from 'react';

export default function useCheckLoginByCode(code: string) {
  const [_code, setCode] = useState<string>(code);
  useEffect(() => {
    if (_code != code) {
      setCode(code);
    }
  }, [code]);
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const timerRef = useRef<NodeJS.Timer>();
  const checkLogin = async () => {
    console.log('useCheckLoginByCode', { isLoading, code: _code });
    if (isLoading) return;
    if (_code) {
      setIsLoading(true);
      try {
        const res = await checkLoginByCodeApi(_code).finally(() =>
          setIsLoading(false)
        );

        setData(JSON.parse(atob(res.result)));
        if (timerRef.current) {
          //@ts-ignore
          clearTimeout(timerRef.current);
        }
      } catch (err) {
        console.error('checkLogin error', err);
        setData(null);
        if (timerRef.current) {
          //@ts-ignore
          clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
          checkLogin();
        }, 3000);
      }
    }
  };
  useEffect(() => {
    checkLogin();
    return () => {
      if (timerRef.current) {
        //@ts-ignore
        clearTimeout(timerRef.current);
      }
    };
  }, [_code]);
  return {
    data,
    isLoading,
  };
}
